let yandexMapsPromise

function loadYandexMaps() {
  if (typeof ymaps3 !== 'undefined') return Promise.resolve(ymaps3)
  if (yandexMapsPromise) return yandexMapsPromise

  yandexMapsPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = 'https://api-maps.yandex.ru/v3/?apikey=580308f6-058a-48d7-bec0-ee398767ea0f&lang=ru_RU'
    script.async = true
    script.onload = () => {
      if (typeof ymaps3 === 'undefined') {
        reject(new Error('Yandex Maps API is unavailable'))
        return
      }
      resolve(ymaps3)
    }
    script.onerror = () => reject(new Error('Failed to load Yandex Maps API'))
    document.head.appendChild(script)
  })

  return yandexMapsPromise
}

document.addEventListener('DOMContentLoaded', () => {
  const mapEl = document.getElementById('map')
  if (!mapEl) return

  const initMap = async () => {
    try {
      const maps = await loadYandexMaps()
      await maps.ready
      const { YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker } = maps

      // готовим слои заранее
      const scheme = new YMapDefaultSchemeLayer({
        customization: [
          {
            tags: {
              any: ['urban_area', 'locality'],
            },
            elements: 'geometry',
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['terrain', 'bathymetry', 'landscape'],
              none: 'land',
            },
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['park', 'cemetery'],
            },
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['vegetation'],
            },
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['industrial', 'construction_site', 'medical', 'sports_ground', 'beach'],
            },
            types: 'polygon',
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: 'transit',
              none: ['transit_location', 'transit_line', 'transit_schema', 'is_unclassified_transit'],
            },
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: 'urban_area',
              none: [
                'residential',
                'industrial',
                'cemetery',
                'park',
                'medical',
                'sports_ground',
                'beach',
                'construction_site',
              ],
            },
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['traffic_light'],
            },
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['entrance'],
            },
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['road'],
              none: ['road_1', 'road_2', 'road_3', 'road_4', 'road_5', 'road_6', 'road_7'],
            },
            elements: 'label.icon',
            stylers: {
              visibility: 'off',
            },
          },
          {
            elements: 'label.text',
            tags: {
              none: ['poi', 'transit'],
            },
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: 'locality',
            elements: 'label',
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['region', 'road_1', 'road_2', 'road_3', 'road_4'],
            },
            elements: 'label',
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['district'],
            },
            elements: 'label',
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: 'admin',
              none: ['country', 'region', 'locality', 'district', 'address'],
            },
            elements: 'label',
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['road_5', 'road_6'],
            },
            elements: 'label',
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['address', 'road_7', 'road_limited', 'road_unclassified', 'road_minor', 'road_construction', 'path'],
            },
            elements: 'label',
            stylers: {
              visibility: 'off',
            },
          },
          {
            tags: {
              any: ['building', 'address', 'fence'],
            },
            stylers: {
              visibility: 'off',
            },
          },
        ],
      })
      const features = new YMapDefaultFeaturesLayer()

      // передаём их третьим аргументом конструктору
      const map = new YMap(
        mapEl,
        {
          location: { center: [37.588763, 55.732154], zoom: 13 },
          copyrightOpen: false,
          mode: 'vector',
        },
        [scheme, features] // ← ключевая строка
      )

      // маркер
      const markerEl = document.createElement('div')
      markerEl.className = 'mapMarker'
      markerEl.innerHTML = `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 0C7.16344 0 0 8.00517 0 17C0 25.9244 5.10665 35.6248 13.0741 39.3489C14.9315 40.217 17.0685 40.217 18.9259 39.3489C26.8934 35.6248 32 25.9243 32 17C32 8.00517 24.8366 0 16 0ZM16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z" fill="#DD071B"/>
                          </svg>`
      map.addChild(new YMapMarker({ coordinates: [37.588963, 55.732354] }, markerEl))
      mapEl.classList.remove('hidden')
    } catch (error) {
      console.error('Yandex Maps initialization failed:', error)
    }
  }

  if (!('IntersectionObserver' in window)) {
    window.addEventListener('load', initMap, { once: true })
    return
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) return
      observer.disconnect()
      initMap()
    },
    { rootMargin: '400px 0px' }
  )

  observer.observe(mapEl)
})
